export const SESSION_ID_CACHE_KEY = 'session-id';
export const SESSION_ID_MAX_DURATION = 1800000; // in miliseconds = 30 minutes
/**
 * Analytics impression threshold: define what percentage of an item in the viewport is considered as "seen"
 * Example: 0.5 = 50%
 */
export const ITEM_IMPRESSION_THRESHOLD = 0.5;

export const IMPRESSIONS_ANALYTICS_FF = 'impressions-analytics';
